<template>
  <section v-if="newEvent">
    <div class="event-form--section-title">
      <div class="section-title__tooltip">
        Clusters
        <Tooltip position="left">
          <template v-slot:text>
            <IconInfo />
          </template>
          <template v-slot:tooltip>
            A Cluster is a collection of one or more zones. Visitor insights and metrics will be provided at a cluster-level. For more details head to the FAQ page.
          </template>
        </Tooltip>
      </div>
      List of available Clusters in your event
    </div>
    <div class="event-form--content">
      <div v-if="newEvent.clusters.length === 0" class="event-form--zones-empty">
        <IconZones />
        <strong>No Clusters to Show yet</strong>
        <p>Create a cluster and assign zones to it</p>
        <AddClusterModal
          v-model:newEvent="newEvent"
          @onClusterAdded="onClusterAdded"
        />
      </div>
      <div v-else>
        <div class="event-form--content-top">
          <AddClusterModal
            v-model:newEvent="newEvent"
            @onClusterAdded="onClusterAdded"
          />
        </div>

        <EditClusterModal
          v-if="editCluster"
          v-model:editCluster="editCluster"
          v-model:newEvent="newEvent"
          :index="editClusterIndex"
          @onClusterEdited="onClusterEdited"
          @onClusterCanceled="onClusterCanceled"
        />

        <ul class="event-form--zones-list">
          <ClusterPreview
          v-for="(cluster, index) in newEvent.clusters"
            :key="index"
            v-model:cluster="newEvent.clusters[index]"
            :index="index"
            @onRemoveCluster="onRemoveCluster(index)"
            @onEditCluster="onEditCluster"
          />
        </ul>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import type { EventTypeNew } from '@/types/Event';
import type { ClusterType } from '@/types/Event';

import Tooltip from '@/components/global/Tooltip.vue';

import EditClusterModal from '@/components/dialogs/ClusterEdit.vue';
import AddClusterModal from '@/components/dialogs/ClusterAdd.vue';
import ClusterPreview from '@/components/events/ClusterPreview.vue';

import IconInfo from '@/icons/IconInfo.svg?component';
import IconZones from '@/icons/events/IconZones.svg?component';

const newEvent = defineModel<EventTypeNew>('newEvent');

const editCluster = ref<ClusterType | null>();
const editClusterIndex = ref<number>(-1);

const onClusterAdded = (newCluster: ClusterType) => {
  if (newEvent.value?.clusters) {
    newEvent.value.clusters.push(newCluster);
  }
}

const onEditCluster = (zone: ClusterType, index: number) => {
  editCluster.value = zone;
  editClusterIndex.value = index;
}

const onRemoveCluster = (index: number) => {
  if (newEvent.value) {
    newEvent.value.clusters.splice(index, 1);
  }
}

const onClusterCanceled = () => {
  editCluster.value = null;
  editClusterIndex.value = -1;
}

const onClusterEdited = () => {
  editCluster.value = null;
  editClusterIndex.value = -1;
}

</script>